import { t } from 'i18next'

import { CUSTOM_LANDING_PAGE_OPTION_ID } from '@pages/IntroducingBroker/Dashboard/ReferralLink/ReferralLink'

import { PopoverInput } from '@ui/components/Popover'

import { NameDto } from '@model/NameDto'
import { ReferralMaterialsUrls } from '@model/ReferralMaterialDto'

import { SetState } from '@global/types/SetState'

interface ReferralLandingPageDropdownProps {
  landingPageUrl: NameDto<string> | undefined
  setLandingPageUrl: SetState<NameDto<string> | undefined>
  shortenedReferralLink?: string
  setShortenedReferralLink: SetState<string | undefined>
  landingPageUrlsFromCategories?: ReferralMaterialsUrls[]
  isLoadingLpUrlsFromCategories: boolean
  shouldUseAliases?: boolean
}

export const ReferralLandingPageDropdown = ({
  landingPageUrl,
  setLandingPageUrl,
  shortenedReferralLink,
  setShortenedReferralLink,
  landingPageUrlsFromCategories,
  isLoadingLpUrlsFromCategories,
  shouldUseAliases,
}: ReferralLandingPageDropdownProps) => {
  return (
    <PopoverInput
      isWidthFixed
      value={landingPageUrl?.id}
      disabled={isLoadingLpUrlsFromCategories}
      dropdownListVariant='compact'
      size='lg'
      label={t('IB.Dashboard.ReferralLink.Select option')}
      options={[
        { id: CUSTOM_LANDING_PAGE_OPTION_ID, name: t('Custom') },
        ...(normalizeLandingPageUrlsFromCategories(
          landingPageUrlsFromCategories,
          shouldUseAliases
        ) ?? []),
      ]}
      onChange={(option) => {
        !!shortenedReferralLink && setShortenedReferralLink(undefined)

        const landingPageUrl = landingPageUrlsFromCategories?.find((url) => url.id === option.id)
        const processedLandingPageUrl = landingPageUrl
          ? { id: landingPageUrl.id, name: landingPageUrl.url }
          : option

        setLandingPageUrl(processedLandingPageUrl)
      }}
    />
  )
}

const normalizeLandingPageUrlsFromCategories = (
  landingPageUrlsFromCategories?: ReferralMaterialsUrls[],
  shouldUseAliases?: boolean
) =>
  landingPageUrlsFromCategories?.map((url) => ({
    id: url.id,
    name: shouldUseAliases ? url.alias || url.url : url.url,
  }))
